import {addComponentKeysets} from '../../../i18n';

import en from './en.json';
import ru from './ru.json';

export default addComponentKeysets({en, ru}, 'DefinitionList');
